import { render, staticRenderFns } from "./GatewayConfigurationPanel.global.vue?vue&type=template&id=9603a472&lang=pug&"
import script from "./GatewayConfigurationPanel.global.vue?vue&type=script&lang=ts&"
export * from "./GatewayConfigurationPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports